import React from 'react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const TermsAndConditions10 = () => {
    const sections = [
        {
            title: '1. Acceptance of Terms',
            content: 'By accessing and using this website, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service.',
        },
        {
            title: '2. Use License',
            content: 'Permission is granted to temporarily download one copy of the materials on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title. Under this license you may not modify or copy the materials, use the materials for any commercial purpose, or attempt to reverse engineer any software on our website.',
        },
        {
            title: '3. Product Information',
            content: 'We strive to provide accurate product descriptions and imagery. However, we do not warrant that product descriptions, pricing, or other content on this site is accurate, complete, reliable, current, or error-free. Colours shown on your screen may vary from actual product colours due to monitor settings.',
        },
        {
            title: '4. Pricing and Payment',
            content: 'All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise. We reserve the right to change prices at any time without prior notice. Payment must be made in full at the time of purchase through the available payment methods.',
        },
        {
            title: '5. Shipping and Delivery',
            content: 'We aim to dispatch all orders within 3-5 business days. Delivery times may vary depending on your location. We are not responsible for delays caused by customs, weather, or other factors beyond our control.',
        },
        {
            title: '6. Returns and Exchanges',
            content: 'Returns are accepted within 14 days of delivery for unused items in their original packaging. Custom or personalised items cannot be returned. Please refer to our Shipping & Returns page for detailed information.',
        },
        {
            title: '7. Intellectual Property',
            content: 'All content on this website, including text, graphics, logos, images, and software, is the property of STHIR and is protected by Indian and international intellectual property laws.',
        },
        {
            title: '8. Limitation of Liability',
            content: 'STHIR shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the website or purchase of any products.',
        },
        {
            title: '9. Changes to Terms',
            content: 'We reserve the right to update or modify these terms at any time without prior notice. Your continued use of the website after any changes constitutes your acceptance of the new terms.',
        },
    ];

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-12 md:py-20 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <h1 className="text-2xl md:text-4xl font-light text-[#1C1917] tracking-tight">Terms & Conditions</h1>
                        <p className="text-[#A8A29E] text-xs font-light mt-3">Last updated: March 2026</p>
                    </div>

                    <div className="max-w-[700px] mx-auto px-5 md:px-8 py-10 md:py-16">
                        <div className="space-y-10">
                            {sections.map((section, index) => (
                                <div key={index}>
                                    <h2 className="text-[#1C1917] text-sm font-normal tracking-wider mb-3">{section.title}</h2>
                                    <p className="text-[#78716C] text-sm font-light leading-[1.8]">{section.content}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default TermsAndConditions10;
